import moment from 'moment-jalaali';

export default function StatsCards({ reports, clients }) {
  const today = moment().startOf('day');
  const weekStart = moment().startOf('week');

  const reportsToday = reports.filter((r) =>
    moment(r.date).isAfter(today)
  ).length;

  const reportsThisWeek = reports.filter((r) =>
    moment(r.date).isAfter(weekStart)
  ).length;

  const pendingFeedback = reports.filter((r) => !r.hasFeedback).length;

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      <Card title="تعداد کاربران" value={clients.length} />
      <Card title="گزارش‌های امروز" value={reportsToday} />
      <Card title="گزارش‌های این هفته" value={reportsThisWeek} />
      <Card title="بدون فیدبک" value={pendingFeedback} color="text-red-500" />
    </div>
  );
}

function Card({ title, value, color = 'text-blue-600' }) {
  return (
    <div className="bg-white shadow p-4 rounded-xl text-center">
      <p className="text-gray-500 text-sm">{title}</p>
      <p className={`text-xl font-bold mt-1 ${color}`}>{value}</p>
    </div>
  );
}
